import React from "react";
import { Box, Button, Modal, Typography, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

export default function ConfirmationModal(props) {

    const handleSubmit = () => {
      props.onSubmit();
      props.handleClose();
    }

    return <Modal
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
    <Box sx={modalStyle}>
      <IconButton sx={{float:"right", top: "-15px", right: "-15px", padding: "0px"}} onClick={props.handleClose}>
        <CloseIcon></CloseIcon>
      </IconButton>
      <Typography id="modal-modal-title" variant="h6" component="h2">
        {props.notification}
      </Typography>
      <br/>
      <Button sx={{marginTop:"15px", marginLeft:"5px"}} onClick={handleSubmit} variant="outlined" color="primary" size="large">Yes</Button>
      <Button sx={{marginTop:"15px", marginLeft:"5px", float:"right"}} onClick={props.handleClose} variant="outlined" color="secondary" size="large">No</Button>
    </Box>
  </Modal>
}